import { registerRoot } from "remotion"

import { Root } from "./src/Root"

import "./src/styles/globals.css"

registerRoot(Root)
